__turbopack_context__.v({
  "active": "styles-module__qeIjjW__active",
  "checkmark": "styles-module__qeIjjW__checkmark",
  "checkmarkMob": "styles-module__qeIjjW__checkmarkMob",
  "customCheckbox": "styles-module__qeIjjW__customCheckbox",
  "customControlLabel": "styles-module__qeIjjW__customControlLabel",
  "disabled": "styles-module__qeIjjW__disabled",
  "label": "styles-module__qeIjjW__label",
});
